import { flow, get } from 'lodash-es';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import {
  VehicleModel,
  buildMmysMsrpPricesPath,
  getUsedBaseStylePath,
  buildUsedTmvPricingPath,
} from 'client/data/models/vehicle-v2';
import { isPreProd, isUsed } from 'site-modules/shared/utils/publication-states';
import { getParamsFromVehicle } from 'site-modules/shared/utils/core-page/params';
import { buildPreProdContentPath, EditorialReviewModel } from 'client/data/models/editorial-review';
import { PersonalizedSearchModel, PersonalizedSearchPaths } from 'client/data/models/personalized-search';
import { buildMMYSubmodelTrimPhotosPathWithParams, PhotosModel } from 'client/data/models/photos';
import { buildMMYSubmodelTypeAmountsPath, InventoryAggregateModel } from 'client/data/models/inventory-aggregate';

export const headerContentDataProvider = flow(
  component =>
    connectToModel(component, {
      msrpPriceRanges: bindToPath(
        ({ vehicle }) =>
          vehicle &&
          !isPreProd(vehicle.pubStates) &&
          !isUsed(vehicle.pubStates) &&
          buildMmysMsrpPricesPath(getParamsFromVehicle(vehicle)),
        VehicleModel,
        null,
        false
      ),
      estimatedPrice: bindToPath(
        ({ vehicle }) =>
          vehicle && isPreProd(vehicle.pubStates) && buildPreProdContentPath(getParamsFromVehicle(vehicle)),
        EditorialReviewModel,
        preProdContent => preProdContent?.price?.value,
        false
      ),
      editorialRating: bindToPath(
        ({ vehicle }) => vehicle && PersonalizedSearchPaths.getEditorialRatingPath(getParamsFromVehicle(vehicle)),
        PersonalizedSearchModel,
        null,
        false
      ),
      photoUrl: bindToPath(
        ({ vehicle }) =>
          vehicle &&
          buildMMYSubmodelTrimPhotosPathWithParams({
            ...getParamsFromVehicle(vehicle),
            submodel: vehicle.submodels.name,
            width: '300',
          }),
        PhotosModel,
        photos => get(photos, '[0].href', ''),
        false
      ),
      usedTmv: bindToPath(
        ({ vehicle, usedBaseStyle, submodelAmounts }) =>
          vehicle &&
          usedBaseStyle &&
          submodelAmounts &&
          !get(submodelAmounts, `priceRanges["${vehicle.submodels?.slug}"]`) &&
          buildUsedTmvPricingPath(get(usedBaseStyle, 'usedDefaultStyle.id')),
        VehicleModel,
        null,
        false
      ),
    }),
  component =>
    connectToModel(component, {
      submodelAmounts: bindToPath(
        ({ vehicle }) =>
          vehicle &&
          isUsed(vehicle.pubStates) &&
          buildMMYSubmodelTypeAmountsPath({ ...getParamsFromVehicle(vehicle), isUsed: true }),
        InventoryAggregateModel,
        null,
        false
      ),
      usedBaseStyle: bindToPath(
        ({ vehicle }) => vehicle && isUsed(vehicle.pubStates) && getUsedBaseStylePath(getParamsFromVehicle(vehicle)),
        VehicleModel,
        null,
        false
      ),
    })
);
